module.exports = __webpack_public_path__ + "img/itinerary_collaborate_mobile.9c62ea57.png";